import React from 'react';
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import auth_service from '@/Services/Auth';
import { IInitialServerProducts, getInitialServerProducts } from '@/Page/SearchPage/Context/ServerState/actions/getInitialProducts';
import { normalizeQueryParamsBody } from '@/Utils/getNormalizedQueryParams';
import { getInitialServerUserInfo } from '@/Page/SearchPage/Context/ServerState/actions/getUserInfo';
import { IMinUser } from '@/Models/User/IUser';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'next-i18next';
import { getIsSsrMobile } from '@/Utils/getIsSsrMobile';
import { WEBSITE_URL } from '@/Data/Constants';
import { QS } from '@/Services/QS';
import numberService from '@/Services/NumberService';
import { BROWSER_TOKEN_KEY } from '@/Services/Axios';
import UserProductsNew from '@/Page/UserProductsNew';
import { myGetServerSidePropsFuncType, sharedServerSideLogic } from '@/Services/SsrService/sharedServerSideLogic';

export default function UserProductsPageRoute({ user, initialProducts, initialOrderNum }: { user: IMinUser; initialProducts: IInitialServerProducts; initialOrderNum: number }) {
  const { t } = useTranslation(['common']);

  return (
    <>
      <NextSeo
        title={`${user.firstname} ${t('common:user_announcements')} - Joyla | ${user.id}`}
        description={t('common:seo_info.index.description')!}
        canonical={`${WEBSITE_URL}/user/${user.id}`}
        openGraph={{
          url: `${WEBSITE_URL}/user/${user.id}`,
          title: `${user.firstname} ${t('common:user_announcements')} - Joyla | ${user.id}`,
          description: t('common:seo_info.index.description')!,
          images: [
            {
              url: 'https://beta.joyla.uz/static/icons/logo.svg',
              alt: 'Joyla',
            },
          ],
          siteName: 'Joyla',
        }}
      />
      <>
        <UserProductsNew initialProducts={initialProducts} user={user} initialOrderNum={initialOrderNum} />
      </>
    </>
  );
}

function getIdByString(url: string): number {
  const strs = url.split('-');
  return +strs[strs.length - 1];
}

const fn: myGetServerSidePropsFuncType = async (context, sharedSsrValues) => {
  const client_token = context.req.cookies[BROWSER_TOKEN_KEY] || '';
  const default_params = QS.parse(context.resolvedUrl.slice(2), { allowDots: true });
  const qParams = normalizeQueryParamsBody(default_params, true, 'computer');
  const initialOrderNum = numberService.getRandomNumber(11, 100);

  const slug = context.query.id! as string;
  const id = getIdByString(slug);

  const initialProducts = await getInitialServerProducts({ ...qParams, created_by: id }, 'computer', initialOrderNum, client_token);
  const userinfo = await getInitialServerUserInfo(+id);

  return {
    props: {
      user: userinfo.data,
      initialProducts,
      initialOrderNum,
    },
  };
};

export const getServerSideProps: GetServerSideProps = sharedServerSideLogic(fn);
